export default __webpack_public_path__ + "static/media/cubes.a9d4e94a.png";